<template>
    <div class="history shadow-inactive" v-if="players != null">
        <div class="history-container">
            <div class="playernames">
                <div class="playername" v-for="player, idx in players" :key="idx">{{player.player.name}}</div>
            </div>
            <div class="round-container">
                <div class="rounds">
                    <div class="round-counter round-header">{{__('games.round')}}</div>
                    <template v-for="round, idx in history">
                        <div class="round-counter" :key="'h'+idx" v-if="history[idx]">{{idx == 0 ? "-" : idx}}</div>
                    </template>
                </div>
                <div :class="['history-unit', player.winner ? 'winner' : '']" v-for="player, idx in players" :key="'p'+idx">
                    <div class="headers">
                        <div class="slot-headers">
                            <div :class="['slot-header', header.main ? 'main':'']" v-for="header in headers" :key="header.name">{{__(header.name)}}</div>
                        </div>
                    </div>
                    <div class="round" v-for="row, idx2 in history" :key="'r'+idx2">
                        <div :class="['slot', header.main ? 'main':'']" v-for="header in headers" :key="header.name">
                            <template v-if="header.value && row[idx]">
                                <span class="singlescores" v-if="header.value == 'singlescores' && row[idx].singlescores && row[idx].singlescores.length > 0">
                                    <span class="singlescore" v-if="row[idx].singlescores[0]">{{row[idx].singlescores[0].str}}</span>
                                    <span class="singlescore" v-if="row[idx].singlescores[1]">{{row[idx].singlescores[1].str}}</span>
                                    <span class="singlescore" v-if="row[idx].singlescores[2]">{{row[idx].singlescores[2].str}}</span>
                                </span>
                                <span v-else-if="header.value !== 'singlescores'">{{row[idx][header.value]}}</span>
                                &nbsp;
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                players: null,
                history: [],
                headers: [],
            }
        },
        mounted() {
            window.connection.subscribe(this);
            this.update(window.connection.lastUpdate);
        },
        methods: {
            update(data) {
                if (data == null) return;
                if (this.players == null) {
                    this.players = data.players;
                }
                this.history = data.gameState.history;
                this.headers = data.gameState.historyHeaders;
            }
        }
    }
</script>
